module.exports = __webpack_public_path__ + "/static/assets/6a682c7d350ef826308c5630878a651a.png";